import React, { useState } from "react";
import { FaArrowDown, FaArrowRightArrowLeft } from "react-icons/fa6";
import { FaCircleQuestion } from "react-icons/fa6";
import { FaPlus } from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";
import convert from "../assets/images/icon/convert.png";
import bnb from "../assets/images/icon/BNB.png";
import { Tabs } from "@mantine/core";

const Convert = () => {
  const [advancedOpen, setAdvancedOpen] = useState(true);
  const [isToggled , setIsToggled] = useState(false);

 const handleClick = () => {
    setIsToggled(!isToggled);
 }

  const currencies = [
    ["Bitcoin", "Ethereum", "XRP", "BUSD", "Euro", "BNB"],
    ["USDC", "TetherUS", "Litecoin", "Solana", "Dogecoin", "TRON"],
    [
      "Polygon",
      "Cardano",
      "SHIBA INU",
      "Worldcoin",
      "TrueUSD",
      "Stellar Lumens",
    ],
    ["Bitcoin Cash", "Pepe", "Arbitrum", "ChainLink", "Polkadot", "Auction"],
    ["Avalanche", "Compound", "Terra Classic", "Gala", "Injective", "Fantom"],
    [
      "Brazilian Real",
      "Arkham",
      "Optimism",
      "Cosmos",
      "Yield Guild Games",
      "Algorand",
    ],
    [
      "Hedera Hashgraph",
      "ApeCoin",
      "SingularityNET Token",
      "Adventure Gold",
      "Conflux Network",
      "1inch",
    ],
    ["AMP", "Aptos", "Verge", "VeChain", "Filecoin"],
  ];

  return (
    <>
      <div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300">
        <Header />
        <div className="max-w-7xl mx-auto px-4 py-8">
          {/* Heading */}
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold">Tillionx Convert USDT to BTC</h1>
            <p className="text-sm mt-1">
              Instant Price | Guaranteed Price | Any Pair
            </p>
          </div>

          {/* Promo box */}
          <div className="max-w-2xl mx-auto border rounded-lg shadow-sm px-4 py-2 mb-6">
            <div className="flex items-center justify-between">
              <p className="font-medium">
                Trade Convert Recurring to Win a Share of <br />
                19,000 USDC!
              </p>
              <div className="p-2">
                <img src={convert} alt="BTC Icon" className="w-20 h-20" />
              </div>
            </div>
          </div>

          {/* Tabs */}

          <div>
            <Tabs defaultValue="Instant">
              <Tabs.List className="max-w-2xl mx-auto">
                <Tabs.Tab value="Instant" className="hover:bg-transparent">
                  Instant
                </Tabs.Tab>
                <Tabs.Tab value="Recurring" className="hover:bg-transparent">
                  Recurring
                </Tabs.Tab>
                <Tabs.Tab value="Limit" className="hover:bg-transparent">
                  Limit
                </Tabs.Tab>
              </Tabs.List>

              <Tabs.Panel value="Instant">
                <div className="max-w-7xl mx-auto">
                  <div className="max-w-2xl mx-auto">
                    {/* <button className="py-2 border-b-2 border-yellow-400 font-semibold >
                                Instant
                            </button> 
                            <button className="py-2 >Recurring</button>
                            <button className="py-2 >Limit</button> */}

                    {/* <div className="ml-auto flex items-center gap-2 my-4 text-sm >
                    <span>Chart</span>
                    <label className="inline-flex items-center cursor-pointer">
                      <input type="checkbox" className="sr-only peer" />
                      <div className="w-9 h-5 bg-gray-200 rounded-full peer peer-checked:bg-yellow-400 relative after:absolute after:top-0.5 after:left-0.5 after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-4"></div>
                    </label>
                  </div> */}

                    {/* From */}
                    <div className="border rounded-lg p-4 mb-4 shadow-sm mt-8">
                      <div className="flex justify-between items-center text-sm mb-1">
                        <span className="flex items-center gap-1">
                          From <FaCircleQuestion />
                        </span>
                        <span>
                          Available Balance{" "}
                          <span className="font-medium">0 USDT</span>{" "}
                          <FaPlus className="inline ml-1 text-yellow-500" />
                        </span>
                      </div>
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <img src={bnb} alt="USDT" className="w-6 h-6" />
                          <span className="font-medium">USDT</span>
                        </div>
                        <div className="text-right text-sm">
                          <span>0.01 – 7,200,000</span>{" "}
                          <button className="text-yellow-400 font-medium ml-2">
                            Max
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Switch Icon */}
                    <div className="flex justify-center mb-4">
                      <div className="p-2">
                        <FaArrowRightArrowLeft className="" />
                      </div>
                    </div>

                    {/* To */}
                    <div className="border rounded-lg p-4 mb-4 shadow-sm">
                      <div className="flex justify-between items-center text-sm mb-1">
                        <span>To</span>
                        <span>
                          Available Balance{" "}
                          <span className="font-medium">0 BTC</span>
                        </span>
                      </div>
                      <div className="flex items-center gap-2">
                        <img src={bnb} alt="BTC" className="w-6 h-6" />
                        <span className="font-medium">BTC</span>
                      </div>
                      <p className="text-sm text-right mt-2">0.00000009 – 62</p>
                    </div>

                    {/* Input Box */}
                    <button className="bg-primary rounded-lg py-3 text-center font-semibold w-full">
                      Enter an amount
                    </button>
                  </div>
                </div>
                <div className="max-w-7xl mx-auto px-4 py-12">
                  <h2 className="text-2xl font-bold my-2 ">
                    Convert BTC (Bitcoin) to other currencies
                  </h2>
                  <p className=" mb-8">
                    Swap your Bitcoin to other currencies easily in one go!
                  </p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-y-4 gap-x-8">
                    {currencies.flat().map((item, idx) => (
                      <div
                        key={idx}
                        className="flex items-center gap-2 text-sm"
                      >
                        <div className="w-5 h-5 bg-gray-100 rounded-full" />
                        <span>{item}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </Tabs.Panel>

              <Tabs.Panel value="Recurring">
                <div className="max-w-2xl mx-auto py-6 rounded-lg">
                  <div className="border rounded-lg p-4 mb-4">
                    <div className="flex justify-between text-sm mb-1">
                      <span>From</span>
                      <span>
                        Available Balance 0 BTC{" "}
                        <button className="text-yellow-500 font-medium">
                          +
                        </button>
                      </span>
                    </div>
                    <div className="flex justify-between items-center text-lg font-semibold">
                      <div className="flex items-center gap-2">
                        <img src={bnb} alt="btc" className="w-5 h-5" />
                        <span>BTC</span>
                      </div>
                      <span className="">0.00000009 - 62</span>
                    </div>
                  </div>

                  <div className="border rounded-lg p-4 mb-4">
                    <div className="text-sm text-gray-500 mb-1">To</div>
                    <div className="flex justify-between items-center text-lg font-semibold">
                      <div className="flex items-center gap-2">
                        <img src={bnb} alt="usdt" className="w-5 h-5" />
                        <span>USDT</span>
                      </div>
                      <span className="text-yellow-500">100%</span>
                    </div>
                  </div>

                  <div className="mb-4">
                    <label className="text-sm mb-1 block">Frequency</label>
                    <select className="w-full border rounded-lg p-2 bg-transparent">
                      <option>Every 1 Hour</option>
                      <option>Every 4 Hours</option>
                      <option>Every 1 Day</option>
                    </select>
                  </div>

                  <div>
                    <button
                      className="text-sm  font-medium mb-2"
                      onClick={() => setAdvancedOpen(!advancedOpen)}
                    >
                      Advanced Settings (optional){" "}
                      <span>{advancedOpen ? "▲" : "▼"}</span>
                    </button>

                    {advancedOpen && (
                      <>
                        <div className="mb-3">
                          <label className="text-sm  mb-1 block">
                            Plan Name
                          </label>
                          <input
                            type="text"
                            placeholder="Good plan starts with a good name"
                            className="w-full border rounded-lg p-2 text-sm bg-transparent"
                          />
                        </div>

                        {/* Max Period */}
                        <div className="mb-3">
                          <label className="text-sm  mb-1 block">
                            Maximum Period
                          </label>
                          <input
                            type="text"
                            placeholder="Max trigger count"
                            className="w-full border rounded-lg p-2 text-sm bg-transparent"
                          />
                        </div>

                        {/* Limit Price */}
                        <div className="border rounded-lg p-4 mb-4">
                          <div className="text-sm font-medium mb-2">
                            Limit Price
                          </div>
                          <p className="text-xs text-gray-500 mb-2">
                            You can set just the upper price bound or the lower
                            price bound, or set both.
                          </p>
                          <div className="font-semibold text-sm mb-3">
                            1 BTC ≈ 114938.00 USDT
                          </div>

                          <div className="mb-2">
                            <label className="text-sm  mb-1 block">
                              Upper price bound
                            </label>
                            <input
                              type="text"
                              placeholder="Max buy price"
                              className="w-full border rounded-lg p-2 text-sm bg-transparent"
                            />
                          </div>
                          <div>
                            <label className="text-sm  mb-1 block">
                              Lower price bound
                            </label>
                            <input
                              type="text"
                              placeholder="Min buy price"
                              className="w-full border rounded-lg p-2 text-sm bg-transparent"
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </div>

                  <button className="w-full bg-primary font-medium py-2 rounded-lg cursor-not-allowed">
                    Enter an amount
                  </button>
                </div>
                <div className="max-w-6xl mx-auto p-4">
                  <h2 className="text-lg font-semibold mb-4">
                    Recurring Plans
                  </h2>
                  <div className="border rounded overflow-hidden">
                    {/* Table Header */}
                    <div className="grid grid-cols-6 text-sm font-medium px-4 py-2">
                      <span>Plan Name</span>
                      <span>Total PnL (PnL%)</span>
                      <span>Next Invest Time / Create Time</span>
                      <span>Frequency</span>
                      <span>From</span>
                      <span>Action</span>
                    </div>

                    {/* Empty State */}
                    <div className="flex flex-col items-center justify-center py-16 ">
                      <img
                        src="/empty-icon.png"
                        alt="No records"
                        className="w-12 h-12 opacity-40 mb-4"
                      />
                      <div className="text-sm">No Records Found</div>
                    </div>
                  </div>

                  {/* Total Plan Value */}
                  <div className="mt-4 text-sm ">
                    <span className="underline text-green-800">
                      Total Plan Value (USDT)
                    </span>
                    : 0
                  </div>
                </div>
              </Tabs.Panel>

              <Tabs.Panel value="Limit">
                <div className="max-w-2xl mx-auto p-4 space-y-4">
      {/* From Section */}
      <div className="border rounded-xl p-4 space-y-1 shadow-sm">
        <div className="flex justify-between items-center text-sm">
          <span>From</span>
          <span>Available Balance 0 BTC <span className="text-yellow-400">➕</span></span>
        </div>
        <div className="flex justify-between items-center text-xl font-semibold">
          <span className="flex items-center gap-2">
            <img src={bnb} alt="BTC" className="h-5 w-5" />
            BTC
          </span>
          <span className="text-sm">0.00000009 – 62</span>
        </div>
      </div>

      {/* Down Arrow */}
      <div className="flex justify-center">
        <div className="p-2 rounded-full shadow" onClick={handleClick}>
          <FaArrowDown />
        </div>
      </div>

      {/* To Section */}
      <div className="border rounded-xl p-4 space-y-1 shadow-sm">
        <div className="flex justify-between items-center text-sm">
          <span>To</span>
          <span>Available Balance 0 USDT</span>
        </div>
        <div className="flex justify-between items-center text-xl font-semibold">
          <span className="flex items-center gap-2">
            <img src={bnb} alt="USDT" className="h-5 w-5" />
            USDT
          </span>
          <span className="text-sm">0.01 – 7,200,000</span>
        </div>
      </div>

      {/* Price Condition Section */}
      <div className="border rounded-xl p-4 space-y-2 shadow-sm">
        <div className="flex justify-between items-center text-sm">
          <span>When 1 BTC is worth</span>
          <span>Expires in 30 Days ▼</span>
        </div>
        <div className="flex justify-between items-center text-2xl font-bold">
          <span className="flex items-center gap-2">
            <img src={bnb} alt="USDT" className="h-5 w-5" />
            USDT
          </span>
          <span>116154.03</span>
        </div>
        <p className="text-sm pl-6">Market Price 115,646.46 USDT</p>
        <div className="flex gap-2 pl-6">
          <button className="border text-xs px-2 py-1 rounded">+1%</button>
          <button className="border text-xs px-2 py-1 rounded">+5%</button>
          <button className="border text-xs px-2 py-1 rounded">+10%</button>
        </div>
      </div>

      {/* Rate Section */}
      <div className="text-sm pl-2">Rate</div>
      <div className="text-sm pl-2">1 BTC = 116,154.03 USDT</div>

      {/* Enter Amount */}
      <div className="mt-2">
        <button className="w-full bg-primary py-3 rounded-lg cursor-not-allowed" disabled>
          Enter an amount
        </button>
      </div>
    </div>
              </Tabs.Panel>
            </Tabs>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default Convert;
